import { AreaUnit } from '../../../../../shared/graphql/graphql';
import { MIN_ANNUAL_AREA_AMOUNTS } from '../../../../../shared/helpers/constants/areaAmounts';
import { Plan } from '../../../../../shared/helpers/constants/plans';
import type UiStateStore from '../../../uiState/UiStateStore';

/**
 * Validates the checkout data based on the user's input and total used area.
 *
 * @returns `true` if the data is valid, otherwise `false`.
 */
export const validateCheckout = (data: {
  plan: Plan;
  taxId: string;
  taxIdType: string | undefined;
  annualPlan: UiStateStore['annualPlan'];
  areaUnit: AreaUnit;
  totalUsedArea: number;
  totalUsedSeats: number;
  previewGenerated: boolean;
}): boolean => {
  let result = data.taxIdType ? !!data.taxId : true;
  const annualArea = parseInt(data.annualPlan.area, 10);
  const annualSeats = parseInt(data.annualPlan.additionalSeats, 10);

  if (data.plan === Plan.annual) {
    result =
      result &&
      data.previewGenerated &&
      annualArea >= MIN_ANNUAL_AREA_AMOUNTS[data.areaUnit] &&
      annualArea >= data.totalUsedArea &&
      annualSeats >= data.totalUsedSeats;
  }

  return result;
};
